import axios from './common/axios';

export default {
  /*
   Get all redeemed coupons.
   @param {Object} params
   @param {String} params.wishlistId
   */
  fetchAll(params, callback) {
    if (!params) {
      params = {};
    }

    axios
      .get('/cart/discounts', {
        params: {
          wishlist_id: params.wishlistId
        }
      })
      .then(function(res) {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  /*
   Update coupons.
   @param {Object} params
   @param {String} params.wishlistId
   @param {String} params.discountId
   @param {Boolean} params.isUse
   */
  updateCoupon(params, callback) {
    const method = params.isUse ? 'post' : 'delete';

    axios
      .request({
        url: '/cart/discounts',
        method,
        data: {
          id: params.discountId,
          wishlist_id: params.wishlistId
        }
      })
      .then(function(res) {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  /*
   Redeem coupons.
   @param {Object} params
   @param {String} params.wishlistId
   @param {String} params.couponCode
   */
  redeemCoupon(params, callback) {
    if (!params) {
      params = {};
    }

    axios
      .post('/cart/promotion', {
        wishlist_id: params.wishlistId,
        code: params.couponCode
      })
      .then(function(res) {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  }
};
